import ServiceBlock, { ServiceBlockProps } from './ServiceBlock';

export type { ServiceBlockProps };
export default ServiceBlock;
